import React from 'react';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { MissingRequirementsType } from '../../types';
import { defaultMissingRequirements } from '../../utils/metadata';
import OfferChat from './OfferChat';

type PropsType = {
    open: boolean;
    id?: number | null;
    orderId?: number | null;
    recipient: string;
    canWrite?: boolean;
    close: () => void;
    missingRequirements?: MissingRequirementsType;
}

export default function OfferChatPopup({
    open,
    id,
    orderId,
    recipient,
    canWrite,
    close,
    missingRequirements = defaultMissingRequirements
}: PropsType) {
    return (
        <Dialog
            open={open}
            onClose={close}
            PaperProps={{
                sx: { minWidth: { xs: 0, sm: '500px' } }
            }}
        >
            <Box sx={{ position: 'absolute', top: 10, right: 10 }}>
                <IconButton onClick={close}>
                    <Close />
                </IconButton>
            </Box>
            <DialogTitle>
                {recipient}
            </DialogTitle>
            <DialogContent>
                <OfferChat
                    id={id}
                    orderId={orderId}
                    recipient={recipient}
                    canWrite={canWrite}
                    missingRequirements={missingRequirements}
                    maxHeight="800px"
                />
            </DialogContent>
        </Dialog>
    );
}
